'use client';

import * as React from 'react';

import type { ListingBySlugPartial } from '@utils/imperative-node-queries';

import { PropertyManagerBio } from './property-manager-bio';

interface ListingPropertyManagerBioSectionProps {
  listing: ListingBySlugPartial;
}

export const ListingPropertyManagerBioSection: React.FC<
  ListingPropertyManagerBioSectionProps
> = ({ listing }) => {
  return (
    <PropertyManagerBio
      publicPhoneNumber={listing.account.phoneNumber}
      publicEmail={listing.account.email}
      account={listing.account}
    />
  );
};
